module.exports = __webpack_public_path__ + "img/portfolio-02.02a297ba.jpg";